import { render, staticRenderFns } from "./AllInsolvencyEscalations.vue?vue&type=template&id=4d10cee4&scoped=true&"
import script from "./AllInsolvencyEscalations.vue?vue&type=script&lang=js&"
export * from "./AllInsolvencyEscalations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d10cee4",
  null
  
)

export default component.exports